<template>
    <span class="wglErrorMessage">
        {{message}}
        <slot></slot>
    </span>

</template>

<script>
    import _ from 'lodash';

    export default {
        name: "ErrorMessage",
        props : ['error', 'translations'],

        computed : {
            message () {
                return _.get(this.translations, this.error);
            }
        }
    }
</script>

<style scoped>

</style>